import type {Row} from '../../../../hooks/tanstack-table/types'

export function applyGroupNameToRowId(itemId: string, groupName: string): string {
  return `${groupName}-${itemId}`
}

export function groupNameFromRow<T extends object>(item: Row<T>): string {
  const {id} = item
  return id.slice(0, id.lastIndexOf('-'))
}
